import React from 'react';
import utilSvc from '../../utilSvc';

const FormattedDateWithTimeRenderer = <TItem extends object>({
    item,
    colKey,
}: {
    item: TItem;
    colKey: string;
}): JSX.Element => {
    return <>{utilSvc.dt.isValid(item[colKey]) ? utilSvc.dt.toTextWithTime(item[colKey]) : null}</>;
};

export default FormattedDateWithTimeRenderer;
